import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError, shareReplay } from 'rxjs/operators';

export interface AgentCoreConfig {
    regionName: string;
    agentArn: string;
}

@Injectable({
    providedIn: 'root'
})
export class AgentCoreConfigService {
    private config$?: Observable<AgentCoreConfig>;

    constructor(private http: HttpClient) { }

    loadConfig(): Observable<AgentCoreConfig> {
        if (!this.config$) {
            this.config$ = this.http.get<AgentCoreConfig>('./assets/agentcore.json').pipe(
                tap(config => console.log('Agent Core config loaded:', config)),
                catchError(error => {
                    console.error('Error loading agent core config:', error);
                    return of({ regionName: '', agentArn: '' } as AgentCoreConfig);
                }),
                shareReplay(1) // Cache the result
            );
        }
        return this.config$;
    }

    getConfig(): Observable<AgentCoreConfig> {
        return this.loadConfig();
    }
}